import React, { createContext, useContext, useState, useCallback } from 'react';

const SessionContext = createContext(null);

export const SessionProvider = ({ children }) => {
  const [session, setSession] = useState(() => {
    // Try to restore from localStorage
    const saved = localStorage.getItem('drunkSession');
    return saved ? JSON.parse(saved) : null;
  });
  
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [coinBalance, setCoinBalance] = useState(10);
  const [modeConfig, setModeConfig] = useState(null);

  const saveSession = useCallback((sessionData) => {
    setSession(sessionData);
    localStorage.setItem('drunkSession', JSON.stringify(sessionData));
  }, []);

  const clearSession = useCallback(() => {
    setSession(null);
    setMessages([]);
    setCoinBalance(10);
    setModeConfig(null);
    localStorage.removeItem('drunkSession');
  }, []);

  const addMessage = useCallback((message) => {
    setMessages(prev => [...prev, message]);
  }, []);

  const setAllMessages = useCallback((msgs) => {
    setMessages(msgs);
  }, []);

  const updateMessage = useCallback((messageId, updates) => {
    setMessages(prev => prev.map(msg => 
      msg.id === messageId ? { ...msg, ...updates } : msg
    ));
  }, []);

  return (
    <SessionContext.Provider value={{
      session,
      messages,
      isLoading,
      coinBalance,
      modeConfig,
      setModeConfig,
      setCoinBalance,
      setIsLoading,
      saveSession,
      clearSession,
      addMessage,
      setAllMessages,
      updateMessage
    }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
};
